export default "__VITE_ASSET__BbY7snE2__"